import * as $ from "jquery/dist/jquery";
// export for others scripts to use
window.$ = $;
window.jQuery = $;
